import React from 'react'
import { connect } from 'react-redux'

import { ReactModal } from '../../../../../components'
import { MODAL, ORDER } from '../../../../../reduxs'
import { ERROR_ORDER, ORDER_MODAL_ACTION_TEXT } from '../../../../../helpers'

import { ConfirmOrderModalStyle } from './styles'

function ConfirmOrderModal(props) {
  const {
    language,
    colorTheme,
    confirmItems,
    isOpenConfirmOrderModal,
    closeConfirmOrderModal,
    openOrderCounterModal,
    openSuccessOrderModal,
    clearConfirmOrder,
    createOrder,
    setErrorModal,
  } = props

  const handleBackToOrderCounter = () => {
    clearConfirmOrder()
    closeConfirmOrderModal()
    openOrderCounterModal()
  }

  const handleSubmitOrder = async () => {
    closeConfirmOrderModal()

    const response = await createOrder()

    if(response.status) {
      openSuccessOrderModal()
    } else {
      setErrorModal(true, ERROR_ORDER.CREATE)
    }
  }

  return (
    <ReactModal isVisible={isOpenConfirmOrderModal} width={440} borderRadius={8}>
      <ConfirmOrderModalStyle colorTheme={colorTheme}>
        <h2 className='confirm-order__title'>
          {ORDER_MODAL_ACTION_TEXT.CONFIRM_ORDER[language]}
        </h2>
        <div className='confirm-order__list'>
          {confirmItems.map(({itemName, amount, itemId}) => {
            return (
              <div
                key={`${itemName}-${itemId}`}
                className='confirm-order__item'
              >
                <p className='confirm-order__item--name'>{itemName}</p>
                <p className='confirm-order__item--amount'>{amount}</p>
              </div>
            )
          })}
        </div>
        <div className='confirm-order__button'>
          <button
            className='confirm-order__button--back'
            onClick={() => handleBackToOrderCounter()}
          >
            {ORDER_MODAL_ACTION_TEXT.BACK[language]}
          </button>
          <button
            className='confirm-order__button--confirm'
            onClick={() => handleSubmitOrder()}
          >
            {ORDER_MODAL_ACTION_TEXT.CONFIRM[language]}
          </button>
        </div>
      </ConfirmOrderModalStyle>
    </ReactModal>
  )
}

const mapStateToProps = ({ orderReducer, accountReducer, modalReducer }) => {
  return {
    confirmItems: orderReducer.confirmItems,
    colorTheme: accountReducer.user.colorThemePalette,
    isOpenConfirmOrderModal: modalReducer.orderModal.isOpenConfirmOrderModal,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeConfirmOrderModal: () => dispatch(MODAL.action.setConfirmOrderModal(false)),
    openOrderCounterModal: () => dispatch(MODAL.action.setOrderCounterModal(true)),
    openSuccessOrderModal: () => dispatch(MODAL.action.setSuccessOrderModal(true)),
    clearConfirmOrder: () => dispatch(ORDER.action.clearConfirmOrder()),
    createOrder: () => dispatch(ORDER.action.createOrder()),
    setErrorModal: (isOpen, text) => dispatch(MODAL.action.setErrorModal(isOpen, text)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmOrderModal)
